module.exports = __webpack_public_path__ + "img/certificate7.aa13dfc7.png";